import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconStaticReminderChristmas = function IconStaticReminderChristmas(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#E2E3E6",
    d: "M14 33.667 24 12v26c-7.615 0-10-4.333-10-4.333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34 33.667 24 12v26c7.615 0 10-4.333 10-4.333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    fillRule: "evenodd",
    d: "M24 11a1 1 0 0 1 .908.58l10 21.668a1 1 0 0 1-.032.9l-.876-.48c.876.482.875.483.875.483l-.002.004-.004.007-.01.019a3 3 0 0 1-.148.233 7 7 0 0 1-.438.575 9.6 9.6 0 0 1-1.844 1.665C30.71 37.855 28.01 39 24 39c-4.01 0-6.711-1.145-8.429-2.347a9.6 9.6 0 0 1-1.844-1.665 7 7 0 0 1-.552-.752l-.033-.056-.011-.019-.004-.007-.002-.003s-.001-.002.875-.484l-.876.482a1 1 0 0 1-.032-.901l4-8.667a1 1 0 0 1 1.816.838l-3.76 8.147.108.133c.294.348.767.829 1.462 1.315C18.096 35.979 20.396 37 24 37s5.904-1.021 7.282-1.986a7.6 7.6 0 0 0 1.57-1.448L24 14.386l-3.246 7.033a1 1 0 0 1-1.816-.838l4.154-9A1 1 0 0 1 24 11",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    fillRule: "evenodd",
    d: "M23.058 31.279c-2.944-1.654-5.283-3.74-6.214-5.415l1.312-.728c.735 1.324 2.797 3.24 5.636 4.835 2.816 1.582 6.272 2.779 9.708 2.779v1.5c-3.765 0-7.475-1.303-10.442-2.971",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    fillRule: "evenodd",
    d: "m29.9 25.55.6.45.6.45-.003.003-.004.007-.017.021a8 8 0 0 1-.281.346c-.195.231-.482.556-.858.945a24 24 0 0 1-3.315 2.84c-2.9 2.061-7.174 4.138-12.622 4.138v-1.5c5.052 0 9.028-1.923 11.753-3.861a22.6 22.6 0 0 0 3.107-2.66 17 17 0 0 0 .983-1.105l.046-.06.01-.012zm-9.123-8.352L21.5 17c.724-.197.724-.198.723-.198v-.001l.002.006.01.033q.015.049.049.148a7.942 7.942 0 0 0 1.297 2.287 6.7 6.7 0 0 0 1.79 1.55 15 15 0 0 0 .923-2.077l1.412.504c-.199.558-.51 1.327-.96 2.176A7.6 7.6 0 0 0 29 21.75v1.5c-1.158 0-2.166-.19-3.04-.502-1.634 2.446-4.423 5.002-8.96 5.002v-1.5c3.75 0 6.13-2.05 7.587-4.147a8.2 8.2 0 0 1-2.168-1.878 9.4 9.4 0 0 1-1.55-2.74 6 6 0 0 1-.085-.26l-.005-.018-.002-.006z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA6B6",
    d: "M36 34a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    fillRule: "evenodd",
    d: "M33 35.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m0 1.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA6B6",
    d: "M24 38a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    fillRule: "evenodd",
    d: "M21 39.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m0 1.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA6B6",
    d: "M28 31a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    fillRule: "evenodd",
    d: "M25 32.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m0 1.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA6B6",
    d: "M24 18a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    fillRule: "evenodd",
    d: "M21 19.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m0 1.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA6B6",
    d: "M19 29a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    fillRule: "evenodd",
    d: "M16 30.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m0 1.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    fill: "#fff",
    transform: "matrix(-1 0 0 1 21.5 17.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA6B6",
    d: "M33 24a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    fillRule: "evenodd",
    d: "M30 25.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m0 1.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9C406",
    d: "M23.82 7.363a.2.2 0 0 1 .36 0l1.39 2.818a.2.2 0 0 0 .15.11l3.11.451a.2.2 0 0 1 .11.341l-2.25 2.193a.2.2 0 0 0-.057.177l.531 3.097a.2.2 0 0 1-.29.211l-2.78-1.462a.2.2 0 0 0-.187 0l-2.781 1.462a.2.2 0 0 1-.29-.21l.53-3.098a.2.2 0 0 0-.057-.177l-2.25-2.193a.2.2 0 0 1 .111-.34l3.11-.453a.2.2 0 0 0 .15-.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m25.57 10.18-1.19-2.41c-.094-.19-.38-.123-.38.088v7.272a.2.2 0 0 0 .107.177l2.767 1.455a.2.2 0 0 0 .29-.21l-.53-3.098a.2.2 0 0 1 .057-.177l2.25-2.193a.2.2 0 0 0-.111-.34l-3.11-.453a.2.2 0 0 1-.15-.11",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "#00204D",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m25.57 10.18-1.39-2.817a.2.2 0 0 0-.36 0l-1.39 2.818a.2.2 0 0 1-.15.11l-.562.08-2.548.371a.2.2 0 0 0-.11.341l2.25 2.193a.2.2 0 0 1 .057.177l-.531 3.097a.2.2 0 0 0 .29.211l2.78-1.462a.2.2 0 0 1 .187 0l2.781 1.462a.2.2 0 0 0 .29-.21l-.53-3.098a.2.2 0 0 1 .057-.177l2.25-2.193a.2.2 0 0 0-.111-.34l-3.11-.453a.2.2 0 0 1-.15-.11Z"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    fill: "#fff",
    transform: "matrix(-1 0 0 1 30.5 23.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    fill: "#fff",
    transform: "matrix(-1 0 0 1 33.5 33.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    fill: "#fff",
    transform: "matrix(-1 0 0 1 25.5 30.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    fill: "#fff",
    transform: "matrix(-1 0 0 1 21.5 37.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    fill: "#fff",
    transform: "matrix(-1 0 0 1 16.5 28.5)"
  }));
};